module.exports = {"TXTCLI_Bonus":{"id":"TXTCLI_Bonus","defaultMessage":"Бонус"}}